import React from 'react'
import { ShippingAddressDisplayInput } from './ShippingAddressDisplayInput'
import { PurchaseOption } from './PurchaseOption'
import { Box } from '@ztechapps/webui.util'

export const ShippingOptionsPanel = () => {
  return (
    <Box>
      <Box.Body>
        <div className="row">
          <div className="col-lg-6">
            <ShippingAddressDisplayInput />
          </div>
          <div className="col-lg-6">
            <PurchaseOption />
          </div>
        </div>
      </Box.Body>
    </Box>
  )
}
